import { styled, Collapsible } from '@showroomjs/ui';
import { isPlainObject } from '@showroomjs/core';
import * as React from 'react';
import { useConsoleMessage } from '../lib/use-preview-console';
export const ConsolePanel = ({ defaultIsOpen = false, isCompiling, }) => {
    const msgs = useConsoleMessage();
    const [isShown, setIsShown] = React.useState(defaultIsOpen);
    return msgs.length === 0 ? null : (React.createElement(Collapsible.Root, { open: isShown, onOpenChange: setIsShown },
        React.createElement(SummaryBar, null,
            React.createElement(Collapsible.Button, { css: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '$1',
                    fontSize: '$sm',
                } },
                "Console (",
                msgs.length,
                ")",
                ' ',
                React.createElement(Collapsible.ToggleIcon, { hide: isShown, "aria-label": isShown ? 'Hide' : 'View', width: "16", height: "16" }))),
        React.createElement(Collapsible.Content, { animate: true, css: {
                px: 4,
                paddingBottom: 4,
                backgroundColor: '$gray-100',
            } },
            React.createElement(Wrapper, null,
                msgs.map((msg, i) => msg.level === 'fatal' ? (React.createElement(Item, { css: {
                        backgroundColor: '$red-800',
                    }, key: i },
                    msg.count > 1 && React.createElement(Count, null, msg.count),
                    msg.data.map((d, i) => (React.createElement(Content, { content: d, key: i, wrapString: false }))))) : (React.createElement(Item, { key: i },
                    React.createElement(ContentInner, { css: {
                            width: '7ch',
                            color: msg.level === 'error'
                                ? '#FCA5A5'
                                : msg.level === 'info'
                                    ? '#93C5FD'
                                    : msg.level === 'warn'
                                        ? '#FDE68A'
                                        : undefined,
                        } },
                        "[",
                        msg.level,
                        "]"),
                    msg.count > 1 && React.createElement(Count, null, msg.count),
                    msg.data.map((d, i) => (React.createElement(Content, { content: d, key: i })))))),
                isCompiling && React.createElement(Item, null, "Compiling...")))));
};
const Content = ({ content, wrapString = true, }) => {
    if (Array.isArray(content)) {
        return (React.createElement(React.Fragment, null,
            "[",
            content.map((c, i, all) => (React.createElement(React.Fragment, { key: i },
                React.createElement(Content, { content: c, wrapString: wrapString }),
                i !== all.length - 1 && ','))),
            "]"));
    }
    const contentType = typeof content;
    switch (contentType) {
        case 'undefined':
            return (React.createElement(ContentInner, { css: {
                    opacity: '60%',
                } }, "undefined"));
        case 'boolean':
            return (React.createElement(ContentInner, { css: {
                    color: '$blue-100',
                } }, String(content)));
        case 'string':
            return (React.createElement(ContentInner, { css: {
                    color: '$red-100',
                } }, wrapString ? `'${content}'` : content));
        case 'object':
            return content === null ? (React.createElement(ContentInner, { css: {
                    opacity: '60%',
                } }, "null")) : isPlainObject(content) ? (React.createElement(ContentInner, null, JSON.stringify(content))) : (React.createElement("span", null,
                React.createElement(ContentInner, { css: {
                        fontStyle: 'italic',
                    } }, getConstructorName(content)),
                getObjectDetails(content)));
        default:
            return null;
    }
};
const wrapIfString = (val) => typeof val === 'string' ? `'${val}'` : val;
const getObjectDetails = (val) => val instanceof Date
    ? ` (${val.toString()})`
    : val instanceof Map
        ? `(${val.size})${val.size > 0
            ? ` {${Array.from(val.entries())
                .map(([key, value]) => `${wrapIfString(key)} => ${wrapIfString(value)}`)
                .join(', ')}}`
            : ''}`
        : null;
const getConstructorName = (obj) => { var _a, _b; return (_b = (_a = Object.getPrototypeOf(obj)) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b.name; };
const Wrapper = styled('ul', {
    shadow: 'inner',
    backgroundColor: '$gray-800',
    color: 'White',
    display: 'flex',
    flexDirection: 'column',
    gap: '$1',
    py: '$1',
});
const Item = styled('li', {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    columnGap: '$2',
    fontSize: '$sm',
    lineHeight: '$sm',
    fontFamily: 'monospace',
    px: '$2',
});
const Count = styled('span', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    width: 16,
    height: 16,
    fontSize: '$xs',
    lineHeight: '$xs',
    backgroundColor: '$gray-500',
    color: 'White',
});
const ContentInner = styled('span');
const SummaryBar = styled('div', {
    padding: '$1',
    backgroundColor: '$gray-100',
});
//# sourceMappingURL=console-panel.js.map